var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExploreUsa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "usa",
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.878,
    height: 72.878,
    viewBox: "0 0 72.878 72.878",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_54020",
    "data-name": "Path 54020",
    d: "M36.439,72.878A36.439,36.439,0,1,0,0,36.439,36.441,36.441,0,0,0,36.439,72.878Z",
    transform: "translate(0 0)",
    fill: "#f0f0f0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46499",
    "data-name": "Group 46499",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54021",
    "data-name": "Path 54021",
    d: "M75.058,65H42.365V55.48H66.657A36.423,36.423,0,0,1,75.058,65Zm5.385,19.027H42.385V74.509h36.8A36.479,36.479,0,0,1,80.443,84.022ZM44,120.461a36.2,36.2,0,0,0,22.673-7.914H21.332A36.181,36.181,0,0,0,44,120.461ZM75.1,103.053H12.909A36.056,36.056,0,0,1,8.82,93.539H79.187A36.036,36.036,0,0,1,75.1,103.053Z",
    transform: "translate(-7.565 -47.583)",
    fill: "#d80027",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54022",
    "data-name": "Path 54022",
    d: "M16.917,5.671h-.033v.023Zm0,0h3.3L17.108,7.9l1.174,3.644-3.1-2.228-3.077,2.228L13.119,8.4a36.45,36.45,0,0,0-7.044,7.9H7.148L5.184,17.721l-.891,1.566.931,2.9L3.463,20.9,2.249,23.728,3.261,26.9H7.1L4.05,29.152,5.224,32.8l-3.1-2.228L.3,31.9A33.752,33.752,0,0,0,0,36.439H36.439V0A36.275,36.275,0,0,0,16.917,5.671Zm1.358,27.107.027.021h-.02Zm-1.169-3.624,1.169,3.624-3.092-2.206-3.1,2.228,1.174-3.644-3.1-2.228h3.843l1.174-3.644,1.174,3.644H20.2Zm.021-10.607L18.3,22.191l-3.1-2.228-3.1,2.228,1.174-3.644-3.1-2.228h3.843L15.2,12.675l1.174,3.644h3.843ZM28.281,30.572l3.1,2.228L30.2,29.155l3.1-2.228H29.464L28.29,23.284l-1.174,3.644H23.272l3.1,2.228L25.2,32.8ZM30.2,18.547l1.174,3.644-3.1-2.228-3.1,2.228,1.174-3.644-3.1-2.228H27.1l1.174-3.644,1.174,3.644H33.3Zm1.174-6.965L30.2,7.938l3.1-2.228H29.464L28.29,2.067,27.116,5.71H23.272l3.1,2.228L25.2,11.582l3.1-2.228Z",
    transform: "translate(0 0)",
    fill: "#0052b4",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreUsa);
export default __webpack_public_path__ + "static/media/explore-usa.12b04910dc0c1fc4ed973cb1bec89fd1.svg";
export { ForwardRef as ReactComponent };